var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEatery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 35",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_48Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.365,8.32a2.92,2.92,0,0,0-2.59-3.163A2.92,2.92,0,0,0,2.184,8.32,3.163,3.163,0,0,0,3.943,11.3L3.487,21.364a1.442,1.442,0,0,0,0,.148,1.262,1.262,0,1,0,2.52-.148L5.552,11.321A3.144,3.144,0,0,0,7.365,8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4,5.767a.632.632,0,0,0-.61-.61.583.583,0,0,0-.086.015v0a2.353,2.353,0,0,0-2.353,2.353v2.9a2.346,2.346,0,0,0,1.574,2.211l-.2,9.13c0,.021,0,.045,0,.066a1.049,1.049,0,0,0,2.1-.066Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.488,7a7.7,7.7,0,1,0,7.7,7.7A7.7,7.7,0,0,0,14.488,7Zm0,13.391a5.7,5.7,0,1,1,5.7-5.7A5.7,5.7,0,0,1,14.488,20.393Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.488,
    cy: 14.697,
    r: 4.02
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEatery);
export default __webpack_public_path__ + "static/media/eatery.153dc08375f30d6f8b2751968b5f78f7.svg";
export { ForwardRef as ReactComponent };